import { TaskList } from '@tiptap/extension-list'

export type { TaskListOptions } from '@tiptap/extension-list'
export { TaskList } from '@tiptap/extension-list'

export default TaskList
